var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo2X(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 23.177,
    viewBox: "0 0 62 23.177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#00619f}.cls-3{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-58.482 -55.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3319",
    d: "M0 0H23.004V23.177H0z",
    className: "cls-1",
    transform: "translate(97.477 55.454)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3320",
    d: "M0 0H37.953V23.177H0z",
    className: "cls-1",
    transform: "translate(58.482 55.454)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9254",
    fill: "#ec3455",
    d: "M666.082 66.813l8.75-11.358h-1.292l-8.778 11.358z",
    transform: "translate(-554.351)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9255",
    d: "M529.965 202.825c.4 1.119 1.227 4.04 1.556 4.274h-2.173a3.489 3.489 0 0 0-.1-.767c-.093-.332-.878-2.857-.878-2.857h-3.446l-.54.77s.652 2.035.69 2.135c.073.181.382.72.382.72h-2.08s-.054-.312-.073-.442c-.015-.1-.2-.676-.2-.676a6.138 6.138 0 0 0-.6.755c-.127.236-.187.363-.187.363h-1.625s-.054-.312-.074-.442c-.017-.1-.215-.723-.215-.723a7.745 7.745 0 0 0-.584.792 3.975 3.975 0 0 0-.187.373h-1.608s.457-.432.615-.621c.268-.313 1.267-1.621 1.267-1.621l-.4-1.383h-3.417s-1.95 2.564-2.027 2.641a7.643 7.643 0 0 0-.658.984h-1.015v-.646l.039-.038c.031-.024 1.479-1.82 2.81-3.59 1.194-1.543 2.313-3.044 2.411-3.19a9.863 9.863 0 0 0 .583-1.093H520s.057.686.106.855c.047.149 1.122 3.681 1.151 3.721l.592-.762-1.018-3.134a5.522 5.522 0 0 0-.315-.679h2.066a1.829 1.829 0 0 0 .068.563c.082.256.526 1.854.526 1.854s1.409-1.766 1.491-1.891a1.157 1.157 0 0 0 .172-.527h1.721a5.553 5.553 0 0 0-.867.929l-2 2.545s.16.54.235.809c.02.078.036.127.036.135s.041-.048.109-.135c.467-.594 2.6-3.388 2.73-3.631a4.459 4.459 0 0 0 .346-.651h1.681a4.281 4.281 0 0 0 .09.639zm-2.554-2.646a22.537 22.537 0 0 1-1.7 2.3h2.3s-.443-1.371-.521-1.68a2.47 2.47 0 0 1-.046-.6c0-.031-.005-.076-.031-.017m-8.827 0a22.957 22.957 0 0 1-1.7 2.3h2.3s-.447-1.371-.525-1.68a2.3 2.3 0 0 1-.045-.6c0-.031-.007-.076-.033-.017m3.458 5.354l.631-.868c-.057-.062-.411-1.144-.411-1.144l-.612.8z",
    className: "cls-3",
    transform: "translate(-414.91 -130.768)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3321",
    d: "M0 0H1.306V8.59H0z",
    className: "cls-3",
    transform: "translate(63.526 67.805)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3322",
    d: "M0 0H1.307V8.59H0z",
    className: "cls-3",
    transform: "translate(69.947 67.805)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3323",
    d: "M0 0H1.304V5.348H0z",
    className: "cls-3",
    transform: "translate(81.758 71.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3324",
    d: "M0 0H1.308V5.348H0z",
    className: "cls-3",
    transform: "translate(89.408 71.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9256",
    d: "M137.721 236.69a2.556 2.556 0 0 1 2.876-.072 1.968 1.968 0 0 1 .6.843 4.175 4.175 0 0 1 .149 2.232 2.03 2.03 0 0 1-2.509 1.925c-.9-.174-1.129-.516-1.129-.516a3.835 3.835 0 0 0 1.388-.123c.654-.209.8-.544.905-1.228a4.1 4.1 0 0 0-.351-2.612c-.444-.448-1.886-.392-1.886-.392s-.081-.035-.042-.056",
    className: "cls-3",
    transform: "translate(-72.5 -165.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9257",
    d: "M212.609 236.613a2.725 2.725 0 0 1 2.771-.16 1.925 1.925 0 0 1 .611 1.543l.006 3.548-1.31.015-.01-3.712s.01-.937-.794-1.094a3.7 3.7 0 0 0-1.265-.075s-.042-.039-.008-.065",
    className: "cls-3",
    transform: "translate(-140.928 -165.161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9258",
    d: "M272.362 236.889a3.37 3.37 0 0 1 3.043-.181 1.775 1.775 0 0 1 .664 1.542l.01 3.548-1.312.015-.012-3.712a1.14 1.14 0 0 0-.976-1.095 4.8 4.8 0 0 0-1.4-.051s-.049-.042-.012-.068",
    className: "cls-3",
    transform: "translate(-195.566 -165.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9259",
    d: "M348.778 237.448a1.959 1.959 0 0 1 1.656-1.218v1.218z",
    className: "cls-3",
    transform: "translate(-265.463 -165.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9260",
    d: "M378.215 219.187v1.524h1.47v.578H378.2v3.3s-.031.921.766.865.774.024.774.024a.116.116 0 0 1-.042.114 2.016 2.016 0 0 1-1.846.435 1.4 1.4 0 0 1-.712-.461 2.068 2.068 0 0 1-.252-.948c-.007-.035 0-4.783 0-4.783l1.159-.652z",
    className: "cls-3",
    transform: "translate(-291.163 -149.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9261",
    d: "M264.6 262.728a.845.845 0 0 1 .193-.119 1.782 1.782 0 0 1 .9-.076s.186 0 .065-.087a2.006 2.006 0 0 0-1.112-.407 1.555 1.555 0 0 0-1.667 1.369 2.611 2.611 0 0 0 .156.984 1.278 1.278 0 0 0 1.137.89 1.821 1.821 0 0 0 1.509-.415c0-.056-.038-.062-.067-.054s-1.13.139-1.312-.488a2.587 2.587 0 0 1-.039-1.185.965.965 0 0 1 .238-.411",
    className: "cls-3",
    transform: "translate(-187.001 -188.87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9262",
    fill: "#1e91cf",
    d: "M419.933 198.274h1.322l-1.31 1.5z",
    transform: "translate(-330.533 -130.598)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9263",
    fill: "#fbb33c",
    d: "M428.533 209.088v2.331l-2.047-2.333z",
    transform: "translate(-336.523 -140.481)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2X);
export default __webpack_public_path__ + "static/media/logo_2x.b7540b97298d963e6b60f876c78444fc.svg";
export { ForwardRef as ReactComponent };